import { removePropertyEmpty } from '@/utils/index'
import { Service } from '../config'

class CategoryService extends Service {
  path = 'categoria'

  async get(params: any) {
    const httpResponse = await this.httpClient.get(this.path, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async categoriaVistoria(params: any) {
    const httpResponse = await this.httpClient.get('/categoriavistoria', {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }


  async download(params: any) {
    const httpResponse = await this.httpClient.get(`${this.path}/excel`, {
      params: removePropertyEmpty(params)
    })
    return httpResponse
  }

  async post(params: any) {
    const httpResponse = await this.httpClient.post(this.path, params)
    return httpResponse
  }
  async postCategoriaVistoria(params: any) {
    const httpResponse = await this.httpClient.post('categoriavistoria', params)
    return httpResponse
  }

  async delete(params: any) {
    const httpResponse = await this.httpClient.delete(
      this.path + `?categoriaId=${params}`
    )
    return httpResponse
  }

  async put(params: any) {
    const httpResponse = await this.httpClient.put(
      this.path + `?categoriaId=${params.id}`,
      { nome: params.nome }
    )
    return httpResponse
  }
}

export const categoryService = new CategoryService()
